// 法语
export default {
  Login: {
    Title: "Connectez-vous à votre compte",
    describe: "Veuillez vous connecter ou créer un compte pour commencer.",
    Google: "Continuer avec Google",
    Apple: "Continuer avec Apple",
    or: "OU",
    Emailplaceholder: "Adresse e-mail",
    Passwordplaceholder: "Mot de passe",
    Login: "Se connecter",
    forgot: "Mot de passe oublié ?",
    notAccount: "Vous n'avez pas de compte Fineshare ?",
    Signup: "S'inscrire",
    InvalidEmail: "Format d'email invalide.",
    InvalidPassword: "Le mot de passe doit contenir au moins 6 caractères.",
    loading: "Chargement...",
    login: "Se connecter",
    errorText:
      "Échec de la connexion, veuillez vérifier votre nom d'utilisateur et votre mot de passe.",
  },
  signup: {
    Title: "Créez votre compte",
    describe: "Créez votre compte Fineshare en quelques secondes.",
    Google: "S'inscrire avec Google",
    Apple: "S'inscrire avec Apple",
    or: "OU",
    Emailplaceholder: "Entrez l'adresse e-mail",
    Passwordplaceholder: "Entrez un mot de passe de 6 caractères",
    Already: "Vous avez déjà un compte ?",
    Login: "Se connecter",
    By: "En créant un compte, j'accepte d'avoir lu et accepté la",
    Privacy: "Politique de confidentialité",
    Terms: "Conditions d'utilisation",
    and: "et",
    signupText: "Créer votre compte",
    InvalidEmail: "Format d'email invalide.",
    InvalidPassword: "Le mot de passe doit contenir au moins 6 caractères.",
    loading: "Chargement...",
    passwordError: "L'adresse e-mail est déjà enregistrée",
    again: "Vous faites trop de demandes, veuillez réessayer plus tard.",
    Registration:
      "Échec de l'inscription, veuillez vérifier votre e-mail et votre mot de passe.",
    hasRegistered: "L'adresse e-mail est déjà enregistrée",
    Title2: "Créez votre compte Fineshare",
  },
  Home: {
    Welcome: "Bienvenue dans le Centre de Comptes Fineshare",
    Hi: "Salut,",
    Order: "Mes Commandes",
    orders: "Voir nos commandes d'achat",
    Learn: "En savoir plus",
    Product: "Gérer les Produits",
    products: "Voir mes produits achetés",
    Setting: "Paramètres du Compte",
    Settings: "Détails du compte et changement de mot de passe",
    account: "Tirez le meilleur parti de votre compte",
    FineCam: "FineCam",
    FineCams: "Créez et partagez vos vidéos inspirantes partout",
    FineVoice: "FineVoice",
    FineVoices: "Créez des voix off avec vos voix préférées, à votre manière",
    VoiceTrans: "VoiceTrans",
    VoiceTranss: "Transformez votre voix, transmettez vos émotions",
    Singify: "Singify",
    Singifys: "Créez des reprises AI avec les voix que vous souhaitez",
  },
  success: {
    Congratulations: "Félicitations !",
    successfully: "Votre compte Fineshare a été créé avec succès.",
  },
  successapp: {
    Successful: "Connexion réussie !",
    successfully1:
      "Vous vous êtes connecté avec succès à votre compte Fineshare et vous pouvez maintenant commencer à utiliser l'application.",
    successfully2:
      "Vous vous êtes connecté avec succès à votre compte Fineshare. Vous pouvez maintenant fermer cette fenêtre et commencer à utiliser l'application.",
    Go: "Aller au Centre Utilisateur Fineshare",
  },
  forgot: {
    ForgotPas: "Mot de passe oublié ?",
    Enter1: "Entrez l'email pour réinitialiser votre mot de passe",
    Enter2:
      "Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    exmple: "nom@exemple.com",
    Back: "Retour à la connexion",
    submitText: "Envoyer",
    errorText: "Veuillez entrer votre adresse email",
    loading: "chargement...",
    sent: "Nous avons envoyé un email à votre adresse",
    notExist: "Votre email n'existe pas, veuillez vérifier votre email",
    Reset: "Échec de la réinitialisation, veuillez vérifier votre email",
  },
  account: {
    Settings: "Paramètres du Compte",
    Change: "Modifiez vos détails de compte, mots de passe et plus.",
    Personal: "Informations Personnelles",
    email: "E-mail :",
    Name: "Nom d'utilisateur :",
    Edit: "Éditer",
    title: "Changer le nom d'utilisateur",
    message: "Le nom saisi ne peut pas être vide.",
    placeholder: "Veuillez entrer votre nom d'utilisateur",
    Reset: "Réinitialiser le mot de passe",
    Resets:
      "Vous pouvez réinitialiser votre mot de passe, entrez 6 chiffres ou plus et un mot de passe",
    ResetPas: "Réinitialiser le mot de passe",
    Delete: "Supprimer le compte",
    Deletes:
      "Cela supprimera définitivement votre compte et toutes ses données, et vous ne pourrez pas réactiver ce compte.",
    sure: "Êtes-vous sûr de vouloir supprimer votre compte Fineshare ?",
    sures:
      "Une fois votre compte supprimé, toutes vos données sur Fineshare seront définitivement supprimées. Pour continuer la suppression du compte, nous avons envoyé un code de vérification. Veuillez entrer le code et cliquer sur Confirmer.",
    Deletebtn: "Supprimer",
    Deleteplaceholder: "Veuillez entrer le code de vérification à 6 chiffres",
  },
  order: {
    Order: "Mes Commandes",
    history: "L'historique de vos commandes est enregistré sur cette page",
    dont: "Vous n'avez pas encore de produit",
    Buy: "Achetez maintenant pour plus d'optimisation, cliquez sur le bouton ci-dessous pour l'obtenir maintenant",
    BuyBtn: "Acheter Maintenant",
    OrderId: "ID de Commande :",
    Price: "Prix :",
    Date: "Date de Commande :",
  },
  Product: {
    Product: "Mon Produit",
    products: "Les produits enregistrés dans votre compte",
    dont: "Vous n'avez pas encore de produit",
    Management: "Gérer les Appareils >",
  },
  redeem: {
    Redeem: "Échanger l'Abonnement",
    products: "Ici, vous pouvez échanger des produits Fineshare",
    Please: "Veuillez entrer votre code de rédemption",
    placeholder: "Code de rédemption",
    Submit: "Soumettre",
    Notes: "Notes :",
    Notes1: "1. Format du code de rédemption : XXXXX;",
    Notes2:
      "2. Pour voir vos produits échangés, cliquez sur le menu 'Produit'.",
    Successfully: "Échange réussi",
    Follow:
      "Suivez les étapes ci-dessous pour commencer à utiliser VoiceTrans :",
    step1: "1. Téléchargez et installez Fineshare VoiceTrans.",
    step2: "2. Ouvrez VoiceTrans et allez à ",
    Account: "Compte",
    step3:
      "3. Entrez votre email et mot de passe pour vous connecter à votre compte Fineshare.",
    Tips: "Conseils : Pour une meilleure utilisation, lisez le ",
    guide: "guide",
    Redemption: "Échec de l'échange",
    redeemed:
      "Le code de rédemption a été utilisé. Veuillez ouvrir le logiciel et vous reconnecter à votre compte pour commencer à l'utiliser.",
    Failed: "Échec de l'échange",
    check: "Veuillez vérifier votre code de rédemption.",
  },
  details: {
    Product: "Mon Produit",
    products:
      "Tous les produits que vous avez achetés se trouvent sur cette page",
    Back: "Retour à la liste",
    Name: "Nom de l'appareil",
    system: "Système de l'appareil",
    status: "Statut de l'appareil",
    Operation: "Opération",
    Delete: "Supprimer",
    contact:
      "La suppression directe n'est pas encore supportée. Si vous devez supprimer l'appareil, contactez-nous à ",
  },
  nav: {
    Home: "Accueil",
    Account: "Compte",
    Order: "Commande",
    Product: "Produit",
    Redeem: "Échanger",
    Help: "Centre d'aide",
  },
  auth: {
    Authorization: "Autorisation réussie !",
    wait: "Retour à l'application, veuillez patienter...",
  },
  notfound: {
    Not: "Page non trouvée",
    Unfortunately:
      "Malheureusement, la page que vous recherchez n'existe pas ou il y a une erreur dans le lien que vous avez entré.",
    Home: "Aller à la page d'accueil",
  },
  topuser: {
    Settings: "Paramètres du compte",
    language: "Langue",
    Logout: "Se déconnecter",
  },
  loginweb: {
    Conversion: "La conversion va bientôt commencer",
    currently: "Il y a actuellement ",
    people: " personnes dans la file d'attente !",
    Please:
      "Veuillez vous connecter, nous vous enverrons les résultats par e-mail une fois la conversion terminée.",
    dont: "Je ne veux pas me connecter",
  },
  mobilelogin: {
    Welcome:
      "Bienvenue sur Fineshare ! Veuillez vous connecter pour commencer.",
  },
  reset: {
    Reset: "Réinitialiser un nouveau mot de passe",
    Password:
      "Le mot de passe doit contenir au moins 6 caractères, avec au moins 1 lettre et 1 chiffre.",
    password: "Entrez votre nouveau mot de passe",
    Back: "Retour à la connexion",
    Congratulations: "Félicitations !",
    successfully:
      "Mot de passe réinitialisé avec succès, commencez à vous connecter immédiatement",
    Login: "Se connecter",
    Please: "Veuillez entrer 6 chiffres et lettres",
    failed:
      "Échec de la réinitialisation du mot de passe, cliquez sur le lien de réinitialisation dans votre boîte de réception",
  },
  verification: {
    verification: "Entrez le code de vérification",
    haveverification: "Nous avons envoyé un code de vérification à ",
    Please:
      ". Veuillez entrer le code de vérification que vous avez reçu ci-dessous :",
    Enter: "Entrez le code de vérification à 6 chiffres",
    Resend: "Renvoyer le code de vérification",
    Wait: "Attendez ",
    again: " secondes avant de renvoyer",
    Verify: "Vérifier",
    error: "Erreur du code de vérification",
    verificationcode: "Veuillez entrer le code de vérification",
  },
};
